




















import {Component, Vue, Watch, Prop} from 'vue-property-decorator';
import MenuBase from '@/views/layout/navigation/menu-base';
import UrlMixin from '@/components/query/url-mixin';
import {mixins} from 'vue-class-component';
import { AclMixin } from '@/components/acl/acl-mixin';
import { DialogModeEnum } from '@/services/models/Enums';
import MenuReportActionsMixin, { MenuReportRowAction } from '@/views/layout/navigation/mixins/menu-report-actions-mixin';

@Component
export default class NoDataBlock extends mixins(MenuBase, UrlMixin, AclMixin, MenuReportActionsMixin) {
  @Prop({ default: false })
  conditional!: boolean;

  left: number = 0;

  allWorkspacesSelected: boolean = this.getAllWorkspacesSelected();

  get visible() {
    return !this.conditional || this.$store.state.table.noReportBlockVisible;
  }

  mounted() {
    this.bus.on('report-wrapper-scroll', this.onBusReportWrapperScroll);
    this.bus.on('report-update-complete', this.onBusReportUpdateComplete);
    
  }

  beforeDestroy() {
    this.bus.off('report-wrapper-scroll', this.onBusReportWrapperScroll);
    this.bus.off('report-update-complete', this.onBusReportUpdateComplete);
  }

  onBusReportWrapperScroll(event: any) {
    this.left = event.target.scrollLeft;
  }

  onBusReportUpdateComplete() {
    this.allWorkspacesSelected = this.getAllWorkspacesSelected();
  }

  getAllWorkspacesSelected() {
    const { selectedWorkspaces, workspaces } = this.$store.state.user;
    const selectedWorkspacesLength = selectedWorkspaces && selectedWorkspaces.length;
    const totalWorkspacesLength = workspaces && workspaces.length;

    return selectedWorkspacesLength === totalWorkspacesLength;
  }

}
